import { Cloudinary } from "cloudinary-core";

import { shopifyImageResize } from "../Shopify";
// this function must be refactored to force intergers or strings in width and height,
// I saw both uses in the wild

export const cloudinaryApplyWidthHeight = (
  url: string,
  width: any,
  height: any
) => {
  if (url) {
    const uploadIndex = url.indexOf("/upload/");
    const cfitRegex = /(c_fit,)\w+/;
    const heightRegex = /(h_[0-9],)\w+/;
    const widthRegex = /(w_[0-9]\/)\w+/;
    url = url.replace(cfitRegex, "");
    url = url.replace(heightRegex, "");
    url = url.replace(widthRegex, "");

    if (uploadIndex > -1) {
      const newUrl =
        url.slice(0, uploadIndex + 8) +
        `c_fit${height ? ",h_" + height : ""}${width ? ",w_" + width : ""}/` +
        url.slice(uploadIndex + 8, url.length);

      return newUrl;
    } else {
      return url;
    }
  }
  return url;
};

export const getPublicIdFromUrl = (url: URL | string) => {
  // Match the 'GOT' Or 'MERCHSTORES' as the first part
  // Match the image file name without the extension as the second part. ie 'Amazon.png' will extract 'Amazon', and 'Amazon.logo.png' will extract 'Amazon.logo'
  const urlPartsMatch = /\/(GOT|MERCHSTORES)\/(.+?)(\.[^.]*$|$)/g.exec(url.toString());
  if (urlPartsMatch) {
    const app = urlPartsMatch[1];
    const publicId = urlPartsMatch[2];
    return `${app}:${publicId}`;
  }
};

export const generateCloudinaryMockupUrl = (
  imgHeight: number,
  imgWidth: number,
  tags: string[],
  logoUrl: string,
  imgUrl: string,
  cloudinarySource?: "merchstores" | "group-order-tool"
) => {
  const cloudinaryCore = new Cloudinary({
    cloud_name: "merchology",
    upload_preset: cloudinarySource ? cloudinarySource : "merchstores",
  });
  let validImage = false;
  if (imgHeight && imgWidth && tags && logoUrl && imgUrl) {
    validImage = true;
  }
  let areaData = "";
  let mockupDimensions = {
    logoWidth: 0,
    logoX: 0,
    logoY: 0,
  };
  tags.every((tag: string) => {
    const tagSplits = tag.split("=");
    if (tagSplits[0] === "LogoArea") {
      areaData = tagSplits[1];
      return false;
    } else {
      return true;
    }
  });
  if (areaData) {
    const areaDataSplits = areaData.split("-");
    if (areaDataSplits.length !== 3) {
      console.error(
        `Unable to generate logo mockup, LogoArea tag not properly formatted. Should be <img_x_percentage>-<img_y_percentage>-<logo_area_width>, is currently ${areaData}`
      );
      validImage = false;
    } else {
      const logoW = Math.round(imgWidth * (parseInt(areaDataSplits[2]) / 100));
      const logoH = logoW;
      let x = Math.round(imgWidth * (parseInt(areaDataSplits[0]) / 100));
      let y = Math.round(imgHeight * (parseInt(areaDataSplits[1]) / 100));

      let imgW = undefined;
      let imgH = undefined;

      if (imgWidth < imgHeight) {
        imgW = logoW;
        imgH = imgHeight * (logoW / imgWidth);
      } else {
        imgH = logoH;
        imgW = imgWidth * (logoH / imgHeight);
      }
      if (imgW < logoW) {
        x += Math.round((logoW - imgW) / 2);
      }
      if (imgH < logoW) {
        y += Math.round((logoW - imgH) / 2);
      }
      mockupDimensions = {
        logoWidth: logoW,
        logoX: x,
        logoY: y,
      };
    }
  } else {
    console.error("Unable to generate logo mockup, no LogoArea tag present");
    validImage = false;
  }

  const isCloudinaryImage = imgUrl.includes("cloudinary.com");

  return validImage
    ? cloudinaryCore.url(
        isCloudinaryImage
          ? cloudinaryApplyWidthHeight(imgUrl, imgWidth, imgHeight)
          : shopifyImageResize(imgUrl, `${imgWidth}x${imgHeight}`),
        {
          transformation: [
            {
              width: mockupDimensions.logoWidth,
              gravity: "center",
              overlay: getPublicIdFromUrl(logoUrl),
              effect: "make_transparent",
            },
            {
              crop: "crop",
              flags: "layer_apply",
              gravity: "north_west",
              x: mockupDimensions.logoX,
              y: mockupDimensions.logoY,
              format: "png",
            },
          ],
          type: "fetch",
        }
      )
    : shopifyImageResize(imgUrl, `${imgWidth}x${imgHeight}`);
};
